<div class="table-wrapper">
  @if (data) {
    <table>
      <thead >
        <tr >
          <td class="no-border"><br><br></td>
          <th rowspan="1" colspan="2" scope="colgroup" class="header bold centered border-bold-left"  translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.row-head.zuUngunstenDerMaenner</th>
          <th rowspan="1" colspan="2" scope="colgroup" class="header bold centered border-bold-left"  translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.row-head.zuUngunstenDerFraun</th>
          <th rowspan="1" scope="col" class="header bold centered border-bold-left"  translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.row-head.gesamtscore</th>
          <th rowspan="1" scope="col" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.row-head.zuUngunstenDer</th>
          <th rowspan="1" scope="col" class="header bold centered" translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-head.anzahlAllerRisikopaare</th>
          <th rowspan="1" scope="col" class="header bold centered" translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-head.gemischtgeschlechtlichePaare</th>
          <th rowspan="1" scope="col" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-head.anteilRisikopaare</th>
        </tr>
        <tr >
          <td class="header border-bold-left"></td>
          <th scope="col" class="centered border-bold-left" >
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.anzahlRisikopaare' | translate}}<br>
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.anzahlPersonen' | translate}}
          </th>
          <th scope="col" class="centered">
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.durchschnittliche' | translate}}<br>
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.lohnunterschiede' | translate}}
          </th>
          <th scope="col" class="centered border-bold-left">
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.anzahlRisikopaare' | translate}}<br>
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.anzahlPersonen' | translate}}
          </th>
          <th scope="col" class="centered border-bold-right" >
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.durchschnittliche'| translate}}<br>
            {{'m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.col-sub-head.lohnunterschiede' | translate}}
          </th>
          <td class="centered border-bold-left"></td>
          <td class="centered "></td>
          <td class="centered border-bold-left"></td>
          <td class="centered" ></td>
          <td class="centered border-bold-right"></td>
        </tr>
      </thead>
      <tbody>
        <tr class="content" appTableDataRowResultat [rowdata]="data" [rowPropName]="'analyseNurGrundlohn'" [rowHeader]="rowHeaderResultateResKeys[0]"></tr>
        <tr class="content" appTableDataRowResultat [rowdata]="data" [rowPropName]="'analyseFixeGewichtung'" [rowHeader]="rowHeaderResultateResKeys[1]"></tr>
        <tr class="content" appTableDataRowResultat [rowdata]="data" [rowPropName]="'standardAnalyseModell'" [rowHeader]="rowHeaderResultateResKeys[2]"></tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="10" class="hint" translate>
          m2.sprint9.cockpit-kontrolle.modellvarianten.resultate.basisGrundgesamtheit</td>
        </tr>
        <tfoot>
        </table>
      }
    </div>
